export default class UploadFieldValueForSave {
  constructor(
    public fieldId: string,
    public value: string,
    public subGroupValue: string | null
  ) { }
}